import createStateReducer from "../../helpers/createStateReducer";
import reloadingPaymentsStates from "../../states/reloadingPayments";
import deltas from "../../actions/deltas";

const {SET_RELOADING_PAYMENTS_STATE} = deltas.actionTypes;

export default createStateReducer(reloadingPaymentsStates, null, SET_RELOADING_PAYMENTS_STATE);

export const selectIsReloadingPayments = (state) => reloadingPaymentsStates.LOADING === state.states.reloadingPayments.state;
